import React,{ useRef, useEffect } from "react";
import { view } from "../../../views/mapView/MapView";
import Home from "@arcgis/core/widgets/Home";

const HomeWidget = (props: any) => {
    
    const homeWidgetDiv = useRef(null);
    
    useEffect(()=> {
        if(homeWidgetDiv.current){
            const homeWidget = new Home({
                container: homeWidgetDiv.current,
                view: props.view
            }) 
            props.view.ui.add(homeWidget,"top-left")
            
            return ()=> {
                homeWidget.destroy()
            }
        }
    },[])
    
    return(
    <div ref={homeWidgetDiv}></div>
    )   
}

export default HomeWidget
